import { useCallback, useEffect, useState } from 'react';

interface UseLazyImageSwapProps {
  figureRef: React.RefObject<HTMLElement>;
  imageSrc: string;
  imageRef: React.RefObject<HTMLImageElement>;
}

const useLazyImageSwap = ({ figureRef, imageSrc, imageRef }: UseLazyImageSwapProps) => {
  const [aspectRatio, setAspectRatio] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const handleImageLoaded = useCallback((img: HTMLImageElement) => {
    const { naturalWidth, naturalHeight } = img;

    if (naturalWidth && naturalHeight) {
      setAspectRatio(`${naturalWidth}/${naturalHeight}`);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (!figureRef?.current || !imageRef?.current) return;

    const img = new Image();
    img.src = imageSrc;

    img.onload = (event: GlobalEventHandlersEventMap['load']) => {
      handleImageLoaded(event.currentTarget as HTMLImageElement);
      imageRef.current.src = imageSrc;
      figureRef.current.classList.add('is-loaded');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [figureRef, imageSrc, imageRef]);

  return {
    aspectRatio,
    isLoaded,
  };
};

export default useLazyImageSwap;
